module.exports = __webpack_public_path__ + "static/media/arquitect_3.643583cc.jpeg";